import React from "react";
import {useTranslation} from "react-i18next";
import {Checkbox} from "rsuite";
const DeliveryByTrackingCode: React.FC<{onDeliveryByTracking: Function}> = ({onDeliveryByTracking}) => {
    const {t} = useTranslation();

    const handleChangeDeliveryByTracking = (checked: boolean) => {
        onDeliveryByTracking(checked)
    }
    return (
        <div className="mb-15" style={{marginLeft: '-8px'}}>
            <Checkbox
                inline
                onChange={(value, checked) => handleChangeDeliveryByTracking(checked)}
            >
               <p style={{marginTop: "2px"}}>{t('order.sendByTrackingCode')}</p>
            </Checkbox>
        </div>
    )
}

export default DeliveryByTrackingCode;